import { Categorie } from './Categorie.class';
export class CentreInteret extends Categorie {
    /**
     * Constructeur du centre d'intérêt
     * On passe 2 paramètres à super pour attribuer l'idCentreInteret à idCategorie
     * @param centreInteret à construire
     */
    constructor(centreInteret) {
        if (centreInteret) {
            const { idCentreInteret, idCategorie, children } = centreInteret;
            super(idCentreInteret !== null && idCentreInteret !== void 0 ? idCentreInteret : idCategorie, centreInteret);
            this.children = children === null || children === void 0 ? void 0 : children.map((myChildren) => new CentreInteret(myChildren));
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idCentreInteret: this.idCategorie,
            idPere: this.idPere,
            libelle: this.libelle,
            ordre: this.ordre,
            children: this.children,
            nomPere: this.nomPere,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2VudHJlSW50ZXJldC5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkNlbnRyZUludGVyZXQuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBRTlDLE1BQU0sT0FBTyxhQUFjLFNBQVEsU0FBUztJQU0zQzs7OztPQUlHO0lBQ0gsWUFBbUIsYUFBc0M7UUFDeEQsSUFBSSxhQUFhLEVBQUU7WUFDbEIsTUFBTSxFQUFFLGVBQWUsRUFBRSxXQUFXLEVBQUUsUUFBUSxFQUFFLEdBQUcsYUFBYSxDQUFDO1lBRWpFLEtBQUssQ0FBQyxlQUFlLGFBQWYsZUFBZSxjQUFmLGVBQWUsR0FBSSxXQUFXLEVBQUUsYUFBYSxDQUFDLENBQUM7WUFFckQsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsR0FBRyxDQUFDLENBQUMsVUFBVSxFQUFFLEVBQUUsQ0FBQyxJQUFJLGFBQWEsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDO1NBQzdFO0lBQ0YsQ0FBQztJQUVEOzs7T0FHRztJQUNJLEtBQUs7UUFDWCxPQUFPO1lBQ04sZUFBZSxFQUFFLElBQUksQ0FBQyxXQUFXO1lBQ2pDLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTTtZQUNuQixPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87WUFDckIsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1lBQ2pCLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtZQUN2QixPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87U0FDckIsQ0FBQztJQUNILENBQUM7Q0FDRCJ9